export const requestCameraAccessPermission = async () => true;

export const requestFineLocationAccessPermission = async () => true;
